import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { CopyModeDropdown } from './dropdown';

export const PositionCopyModeSection = () => {
  return (
    <div className={stack({ gap: 8 })}>
      <p className={css({ textStyle: 'Text/M/Strong', color: 'content.default.level-5' })}>
        <FormattedMessage id='Copy.r260205.Start_copying_from' />
      </p>
      <CopyModeDropdown />
    </div>
  );
};
